export enum ImageUploadType {
    Single = "single",
    Multi = "multi", // Vertical layout, sortable
    MultiWithLabel = "multi-with-label", // Vertical layout, sortable, with custom labels
    MultiCompact = "multi-compact", // Horizontal layout, squares, no labels
}

export type ImageOptions = {
    // If specified, width/height will be downscaled (keeping ratio) if exceeded
    maxWidth?: number
    maxHeight?: number
    // If specified, warning message will appear when attempting to upload smaller image
    minWidth?: number
    minHeight?: number
    // If true, all images (and their cropped variants) are converted to .jpg
    forceJpeg?: boolean
}

export type ImageUploadData = {
    originalImage: {
        id: string
        url: string
    }
    croppedVariants?: CroppedVariant[]
    label?: string
}

export type CroppedVariant = {
    url: string
    cropCoords: CropCoords
    cropType: CropType
}

export type CropCoords = {
    x: number
    y: number
    width: number
    height: number
}

export type CropOptions = {
    defaultWidth?: number
    defaultHeight?: number
    defaultX?: number
    defaultY?: number
    locked?: boolean // If locked, resizing of crop area is disabled
    stepLabel?: string // Label for aspect ratio step thumbnail, e.g. "Rectangle (2:1 ratio)"
    cropDescription?: string // Longer, description text shown above image while cropping
    // If specified, cropped output will be downscaled (keeping ratio) if exceeded
    maxWidth?: number
    maxHeight?: number
    cropType: CropType
}

export enum CropType {
    Ratio_2_1 = "2:1",
    Ratio_1_1 = "1:1",
    Ratio_4_3 = "4:3",
    Free = "free",
    Ratio_1300_590 = "1300:590",
}
